import ConnectionsPage from "./components/Connections/ConnectionsPage";

const TiktokCallback = () => <ConnectionsPage callbackPlatform="tiktok" />;

export default TiktokCallback;
